import React, { useEffect, memo, createElement } from 'react';
import { CheckCircle, AlertTriangle, Clock, FileText, Shield, Users, BookOpen, Download, Star, ArrowRight, ShieldCheck } from 'lucide-react';
import { PurchasePopup } from './components/PurchasePopup';
import { AccordionItem } from './components/Accordion';
import { ImageCarousel } from './components/ImageCarousel';
const CHECKOUT_URL = 'https://checkout1.edulabs.online/cart/42430491164770:1';
// Images
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/nRmQN5dDhSo1KJDV61imV8/MEGAPACK_SEGURIDAD_E_HIGIENE.png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/c8UQFTyFahUVGVEjRpVmrL/MEGAPACK_SEGURIDAD_E_HIGIENE_(3).png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/sKx3nhXzS4eLpXwD7HMSRV/MEGAPACK_SEGURIDAD_E_HIGIENE_(5).png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/jiSCpnKVSsMy4XGjoQvP9c/MEGAPACK_SEGURIDAD_E_HIGIENE_(6).png';
// Preview images for carousel
const PREVIEW_IMAGES = ['https://cdn.magicpatterns.com/uploads/14ZwQ4CmYkBX6A68f7n5Q6/Captura_de_pantalla_2026-01-03_a_la(s)_8.55.41_p._m..png', 'https://cdn.magicpatterns.com/uploads/qraLYLwGyvDJxT9JKqnanP/Captura_de_pantalla_2026-01-03_a_la(s)_8.55.48_p._m..png', 'https://cdn.magicpatterns.com/uploads/mC9LhDAinWtWdyciPmKxnm/Captura_de_pantalla_2026-01-03_a_la(s)_8.55.53_p._m..png', 'https://cdn.magicpatterns.com/uploads/vfQVLCCsZu9x9AziqRbYXm/Captura_de_pantalla_2026-01-03_a_la(s)_8.55.59_p._m..png', 'https://cdn.magicpatterns.com/uploads/fm7C57VshcazgXAZuY9pZu/Captura_de_pantalla_2026-01-03_a_la(s)_8.56.04_p._m..png'];
export function App() {
  // Meta Pixel initialization
  useEffect(() => {
    // Add Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1207447574130520');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1207447574130520&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    // Cleanup function
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  const scrollToCheckout = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-yellow-200" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      {/* Hero Section */}
      <header className="relative overflow-hidden bg-gradient-to-b from-yellow-50 to-white pt-12 pb-12 lg:pt-16 lg:pb-16" data-id="element-2">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-3">
          <div className="flex flex-col items-center text-center z-10" data-id="element-4">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight mb-3 max-w-5xl" data-id="element-5">
              MEGAPACK SEGURIDAD E HIGIENE EN EL AULA
            </h1>

            <div className="w-full max-w-lg mb-3" data-id="element-6">
              <img src={MAIN_IMAGE} alt="Mega Pack Seguridad e Higiene" onClick={scrollToCheckout} className="w-full cursor-pointer transform transition duration-300 hover:scale-[1.02]" data-id="element-7" />
            </div>

            <p className="text-xl md:text-2xl text-gray-600 mb-2 leading-relaxed max-w-3xl font-medium" data-id="element-8">
              La herramienta{' '}
              <span className="text-orange-500 font-bold" data-id="element-9">todo-en-uno</span>{' '}
              definitiva para resolver TODA tu cursada anual
            </p>
            <p className="text-lg text-gray-600 mb-4 leading-relaxed max-w-2xl" data-id="element-10">
              Diseñado para docentes de escuelas técnicas, formación profesional
              e instructores.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4" data-id="element-11">
              <button onClick={scrollToCheckout} className="bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-3 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-12">
                SÍ, QUIERO RESOLVER MI AÑO
                <ArrowRight className="w-5 h-5" data-id="element-13" />
              </button>
            </div>
            <p className="text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-14">
              <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-15" />
              Compra 100% segura • Acceso inmediato
            </p>
          </div>
        </div>

        {/* Background decoration */}
        <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-yellow-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-16"></div>
        <div className="absolute top-0 left-0 -mt-20 -ml-20 w-96 h-96 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000" data-id="element-17"></div>
      </header>

      {/* Target Audience Section */}
      <section className="py-16 bg-white" data-id="element-18">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
          <h2 className="text-3xl font-bold text-center text-slate-900 mb-12" data-id="element-20">
            Esto es para vos si…
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-21">
            {[{
            icon: <Users className="w-8 h-8 text-orange-500" data-id="element-22" />,
            text: 'Sos docente o instructor de Seguridad e Higiene y querés resolver todo el año con un solo material listo.'
          }, {
            icon: <Clock className="w-8 h-8 text-orange-500" data-id="element-23" />,
            text: 'Perdés horas buscando PDFs, armando fichas, inventando evaluaciones y querés ahorrar tiempo real cada semana.'
          }, {
            icon: <AlertTriangle className="w-8 h-8 text-orange-500" data-id="element-24" />,
            text: 'Te frustra que los alumnos sepan teoría pero no sepan qué hacer ante riesgos reales.'
          }, {
            icon: <BookOpen className="w-8 h-8 text-orange-500" data-id="element-25" />,
            text: 'Querés dar clases profesionales (no escolares) pero no tenés material serio listo para usar.'
          }, {
            icon: <FileText className="w-8 h-8 text-orange-500" data-id="element-26" />,
            text: 'Necesitás simulacros, checklists y actividades reales sin tener que crearlos desde cero.'
          }, {
            icon: <Shield className="w-8 h-8 text-orange-500" data-id="element-27" />,
            text: 'Querés formar alumnos que actúen como futuros técnicos, no solo que memoricen.'
          }].map((item, idx) => <div key={idx} className="flex gap-4 p-6 bg-slate-50 rounded-xl border border-slate-100 hover:border-orange-200 transition-colors" data-id="element-28">
                <div className="flex-shrink-0" data-id="element-29">{item.icon}</div>
                <p className="text-gray-700 font-medium" data-id="element-30">{item.text}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 bg-slate-900 text-white relative overflow-hidden" data-id="element-31">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" data-id="element-32"></div>
        <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-34">
            Por eso creamos el{' '}
            <span className="text-yellow-400" data-id="element-35">
              Mega Pack Seguridad e Higiene
            </span>
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-36">
            Sistema completo de formación anual listo para usar. Menos
            preparación. Más clases que funcionan.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 text-left" data-id="element-37">
            {['Unidades completas', 'Actividades profesionales', 'Simulacros reales', 'Evaluaciones listas', 'Checklists técnicos', 'Todo editable e imprimible'].map((feature, idx) => <div key={idx} className="bg-slate-800 p-4 rounded-lg border border-slate-700 flex items-center gap-3" data-id="element-38">
                <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-39" />
                <span className="font-semibold" data-id="element-40">{feature}</span>
              </div>)}
          </div>

          <div className="mt-12" data-id="element-41">
            <button onClick={scrollToCheckout} className="bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-orange-500/50 transition-all transform hover:-translate-y-1" data-id="element-42">
              ACCEDER AL MEGA PACK HOY
            </button>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="py-20 bg-gray-50" data-id="element-43">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-44">
          <div className="text-center mb-16" data-id="element-45">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-46">
              ¿Qué obtendrás?
            </h2>
            <p className="text-gray-600" data-id="element-47">
              Estas son las razones por las que todos eligen este Mega Pack
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-48">
            {[{
            title: 'Unidades completas',
            desc: 'Introducción, señalización, EPP, prevención, primeros auxilios, emergencias y riesgos reales — cada unidad con actividades y evaluación.',
            icon: '📘'
          }, {
            title: 'Guías de actividades',
            desc: 'Casos reales, inspecciones, evacuaciones, protocolos y prácticas aplicadas.',
            icon: '🛠'
          }, {
            title: 'Checklists y rúbricas',
            desc: 'Para evaluar por competencias reales, no solo por memoria.',
            icon: '📋'
          }, {
            title: 'Planificación anual',
            desc: 'Clases armadas, semana por semana, sin improvisar.',
            icon: '🏫'
          }, {
            title: 'Material editable',
            desc: 'Listo para usar en aula, taller u obra. Todo organizado.',
            icon: '📂'
          }, {
            title: 'Bonos incluidos',
            desc: 'Señalización, EPP y emergencias (material profesional extra).',
            icon: '🎁'
          }].map((item, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-49">
                <div className="text-4xl mb-4" data-id="element-50">{item.icon}</div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-51">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-52">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Outcomes Section */}
      <section className="py-20 bg-white" data-id="element-53">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-54">
          <div className="grid md:grid-cols-2 gap-16" data-id="element-55">
            <div data-id="element-56">
              <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center gap-3" data-id="element-57">
                <span className="bg-blue-100 text-blue-600 p-2 rounded-lg" data-id="element-58">
                  🎓
                </span>
                ¿Qué lograrán tus alumnos?
              </h3>
              <ul className="space-y-4" data-id="element-59">
                {['Analizarán riesgos reales', 'Sabrán cómo actuar ante emergencias', 'Usarán checklists profesionales', 'Tomarán decisiones con criterio técnico', 'Se prepararán para prácticas y pasantías', 'Saldrán realmente listos para el mundo laboral'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-700" data-id="element-60">
                    <CheckCircle className="w-5 h-5 text-blue-500 flex-shrink-0" data-id="element-61" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-62">
              <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center gap-3" data-id="element-63">
                <span className="bg-orange-100 text-orange-600 p-2 rounded-lg" data-id="element-64">
                  👨‍🏫
                </span>
                ¿Qué lograrás vos?
              </h3>
              <ul className="space-y-4" data-id="element-65">
                {['Ahorrarás horas cada semana (todo ya está armado)', 'Enseñarás con seguridad y sin improvisar', 'Tendrás toda la cursada resuelta en un solo material', 'Elevarás el nivel profesional de tus clases', 'Disfrutarás más enseñando sin estrés'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-700" data-id="element-66">
                    <CheckCircle className="w-5 h-5 text-orange-500 flex-shrink-0" data-id="element-67" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 bg-slate-50 border-y border-slate-200" data-id="element-68">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-69">
          <div className="text-center mb-16" data-id="element-70">
            <span className="bg-red-100 text-red-600 font-bold px-4 py-1 rounded-full text-sm tracking-wide uppercase mb-4 inline-block" data-id="element-71">
              Solo por hoy
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900" data-id="element-72">
              Si te unís HOY, recibís estos BONOS GRATIS
            </h2>
          </div>

          <div className="space-y-16" data-id="element-73">
            {/* Bonus 1 */}
            <div className="flex flex-col md:flex-row items-center gap-8 bg-white p-8 rounded-3xl shadow-sm border border-gray-100" data-id="element-74">
              <div className="md:w-1/3 relative group cursor-pointer" onClick={scrollToCheckout} data-id="element-75">
                <div className="absolute top-4 -left-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded shadow-lg z-10 transform -rotate-12" data-id="element-76">
                  GRATIS HOY
                </div>
                <img src={BONUS_1_IMAGE} alt="Bono 1" className="w-full rounded-xl shadow-lg transform group-hover:scale-105 transition-transform duration-300" data-id="element-77" />
              </div>
              <div className="md:w-2/3" data-id="element-78">
                <h3 className="text-2xl font-bold text-orange-500 mb-2" data-id="element-79">
                  BONO #1 — Pack de Señales de Seguridad
                </h3>
                <p className="text-gray-600 text-lg mb-4" data-id="element-80">
                  Señales imprimibles, actividades guiadas y guía docente para
                  enseñar señalización de forma práctica.
                </p>
                <div className="flex items-center gap-2 text-sm text-gray-500 font-medium" data-id="element-81">
                  <span className="line-through" data-id="element-82">Valor: $15</span>
                  <span className="text-green-600" data-id="element-83">HOY: $0</span>
                </div>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="flex flex-col md:flex-row items-center gap-8 bg-white p-8 rounded-3xl shadow-sm border border-gray-100" data-id="element-84">
              <div className="md:w-1/3 relative group cursor-pointer" onClick={scrollToCheckout} data-id="element-85">
                <div className="absolute top-4 -left-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded shadow-lg z-10 transform -rotate-12" data-id="element-86">
                  GRATIS HOY
                </div>
                <img src={BONUS_2_IMAGE} alt="Bono 2" className="w-full rounded-xl shadow-lg transform group-hover:scale-105 transition-transform duration-300" data-id="element-87" />
              </div>
              <div className="md:w-2/3" data-id="element-88">
                <h3 className="text-2xl font-bold text-green-600 mb-2" data-id="element-89">
                  BONO #2 — Kit Profesional de EPP
                </h3>
                <p className="text-gray-600 text-lg mb-4" data-id="element-90">
                  Selección, control y mantenimiento profesional de EPP. Todo lo
                  que necesitás para enseñar protección personal.
                </p>
                <div className="flex items-center gap-2 text-sm text-gray-500 font-medium" data-id="element-91">
                  <span className="line-through" data-id="element-92">Valor: $15</span>
                  <span className="text-green-600" data-id="element-93">HOY: $0</span>
                </div>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="flex flex-col md:flex-row items-center gap-8 bg-white p-8 rounded-3xl shadow-sm border border-gray-100" data-id="element-94">
              <div className="md:w-1/3 relative group cursor-pointer" onClick={scrollToCheckout} data-id="element-95">
                <div className="absolute top-4 -left-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded shadow-lg z-10 transform -rotate-12" data-id="element-96">
                  GRATIS HOY
                </div>
                <img src={BONUS_3_IMAGE} alt="Bono 3" className="w-full rounded-xl shadow-lg transform group-hover:scale-105 transition-transform duration-300" data-id="element-97" />
              </div>
              <div className="md:w-2/3" data-id="element-98">
                <h3 className="text-2xl font-bold text-red-500 mb-2" data-id="element-99">
                  BONO #3 — Kit de Simulacros y Emergencias
                </h3>
                <p className="text-gray-600 text-lg mb-4" data-id="element-100">
                  Guías, registros y afiches listos para ejecutar evacuaciones y
                  emergencias en la escuela o taller.
                </p>
                <div className="flex items-center gap-2 text-sm text-gray-500 font-medium" data-id="element-101">
                  <span className="line-through" data-id="element-102">Valor: $19</span>
                  <span className="text-green-600" data-id="element-103">HOY: $0</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Summary & Pricing Section */}
      <section id="compra" className="py-20 bg-gradient-to-br from-slate-900 to-slate-800 text-white" data-id="element-104">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-105">
          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10 shadow-2xl" data-id="element-106">
            <h2 className="text-3xl font-bold text-center mb-12" data-id="element-107">
              ¿QUÉ HAY EN ESTE MEGA PACK?
            </h2>

            <div className="bg-slate-800/50 rounded-2xl p-8 mb-10" data-id="element-108">
              <div className="grid md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-109">
                <div className="flex items-start gap-3" data-id="element-110">
                  <CheckCircle className="text-yellow-400 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-111" />
                  <div data-id="element-112">
                    <h4 className="font-bold text-white mb-1" data-id="element-113">
                      📘 Unidades completas
                    </h4>
                    <p className="text-sm text-gray-300" data-id="element-114">
                      Introducción, señalización, EPP, prevención, primeros
                      auxilios
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-115">
                  <CheckCircle className="text-yellow-400 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-116" />
                  <div data-id="element-117">
                    <h4 className="font-bold text-white mb-1" data-id="element-118">
                      🛠 Actividades y simulacros
                    </h4>
                    <p className="text-sm text-gray-300" data-id="element-119">
                      Casos reales, inspecciones, evacuaciones y protocolos
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-120">
                  <CheckCircle className="text-yellow-400 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-121" />
                  <div data-id="element-122">
                    <h4 className="font-bold text-white mb-1" data-id="element-123">
                      📋 Checklists y rúbricas
                    </h4>
                    <p className="text-sm text-gray-300" data-id="element-124">
                      Evaluación por competencias profesionales
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-125">
                  <CheckCircle className="text-yellow-400 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-126" />
                  <div data-id="element-127">
                    <h4 className="font-bold text-white mb-1" data-id="element-128">
                      🏫 Planificación anual
                    </h4>
                    <p className="text-sm text-gray-300" data-id="element-129">
                      Clases armadas semana por semana
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-130">
                  <CheckCircle className="text-yellow-400 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-131" />
                  <div data-id="element-132">
                    <h4 className="font-bold text-white mb-1" data-id="element-133">
                      📂 Libro digital PDF
                    </h4>
                    <p className="text-sm text-gray-300" data-id="element-134">
                      Formato PDF editable, listo para imprimir y personalizar
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-135">
                  <CheckCircle className="text-yellow-400 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-136" />
                  <div data-id="element-137">
                    <h4 className="font-bold text-yellow-400 mb-1" data-id="element-138">
                      🎁 3 Bonos profesionales
                    </h4>
                    <p className="text-sm text-yellow-200" data-id="element-139">
                      Señalización, EPP y Emergencias (GRATIS HOY)
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8 border-2 border-yellow-400/30" data-id="element-140">
              <div className="mb-6" data-id="element-141">
                <p className="text-gray-400 text-base mb-2" data-id="element-142">
                  Precio Regular:{' '}
                  <span className="line-through decoration-red-500 text-xl" data-id="element-143">
                    $49
                  </span>
                </p>
                <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-144">
                  <span className="text-6xl md:text-7xl font-extrabold text-white" data-id="element-145">
                    $14
                  </span>
                  <span className="bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full uppercase animate-pulse" data-id="element-146">
                    70% OFF
                  </span>
                </div>
                <p className="text-yellow-400 font-bold text-lg" data-id="element-147">
                  ¡Solo por HOY!
                </p>
              </div>

              <button onClick={() => window.location.href = CHECKOUT_URL} className="w-full bg-orange-500 hover:bg-orange-600 text-white text-base md:text-lg font-bold py-3 px-6 rounded-xl shadow-xl hover:shadow-orange-500/50 transition-all transform hover:-translate-y-1 mb-6 flex items-center justify-center gap-2 mx-auto max-w-md" data-id="element-148">
                <span data-id="element-149">SÍ, QUIERO ACCEDER AHORA</span>
                <ArrowRight className="w-5 h-5" data-id="element-150" />
              </button>

              <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-300" data-id="element-151">
                <span className="flex items-center gap-1.5" data-id="element-152">
                  <Download className="w-4 h-4 text-green-400" data-id="element-153" /> Acceso
                  inmediato
                </span>
                <span className="hidden md:inline text-gray-600" data-id="element-154">•</span>
                <span className="flex items-center gap-1.5" data-id="element-155">
                  <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-156" /> Pago 100%
                  seguro
                </span>
                <span className="hidden md:inline text-gray-600" data-id="element-157">•</span>
                <span className="flex items-center gap-1.5" data-id="element-158">
                  <BookOpen className="w-4 h-4 text-green-400" data-id="element-159" /> Acceso de por
                  vida
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Preview Section */}
      <section className="py-20 bg-white" data-id="element-160">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-161">
          <div className="text-center mb-12" data-id="element-162">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-163">
              Mirá el contenido por dentro
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-164">
              Explorá algunas páginas del material para ver la calidad y
              organización profesional que recibirás
            </p>
          </div>

          <ImageCarousel images={PREVIEW_IMAGES} data-id="element-165" />

          <div className="text-center mt-12" data-id="element-166">
            <button onClick={scrollToCheckout} className="bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-orange-500/30 transition-all transform hover:-translate-y-1" data-id="element-167">
              QUIERO ACCEDER AL MATERIAL COMPLETO
            </button>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white" data-id="element-168">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-169">
          <h2 className="text-3xl font-bold text-center text-slate-900 mb-12" data-id="element-170">
            Lo que otros docentes dicen…
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-171">
            {[{
            name: 'Laura M.',
            quote: 'Ahora tengo todo el año resuelto. Entro al aula con tranquilidad y mis alumnos trabajan como técnicos.',
            role: 'Docente Técnica'
          }, {
            name: 'Ricardo P.',
            quote: 'Me ahorra horas de preparación. Está todo listo.',
            role: 'Instructor FP'
          }, {
            name: 'Daniela S.',
            quote: 'Por fin un material serio y profesional.',
            role: 'Profesora SyH'
          }].map((t, idx) => <div key={idx} className="bg-gray-50 p-8 rounded-2xl border border-gray-100 relative" data-id="element-172">
                <div className="text-orange-400 mb-4" data-id="element-173">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 inline-block fill-current" data-id="element-174" />)}
                </div>
                <p className="text-gray-700 italic mb-6" data-id="element-175">"{t.quote}"</p>
                <div className="font-bold text-slate-900" data-id="element-176">{t.name}</div>
                <div className="text-sm text-gray-500" data-id="element-177">{t.role}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-20 bg-blue-50" data-id="element-178">
        <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-179">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-lg border border-blue-100" data-id="element-180">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-181">
              <ShieldCheck className="w-10 h-10 text-blue-600" data-id="element-182" />
            </div>
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-183">
              Garantía sin preguntas
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-184">
              Probalo 7 días sin riesgo. Si no te sirve, te devolvemos el 100%
              de tu dinero. Estamos tan seguros de la calidad de este material
              que asumimos todo el riesgo.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white" data-id="element-185">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-186">
          <h2 className="text-3xl font-bold text-center text-slate-900 mb-12" data-id="element-187">
            Preguntas frecuentes
          </h2>
          <div className="space-y-2" data-id="element-188">
            <AccordionItem question="¿Cómo recibo los materiales?" answer="Acceso digital inmediato. Una vez realizado el pago, recibirás un correo electrónico con los datos de acceso a la plataforma donde podrás descargar todo el material." data-id="element-189" />
            <AccordionItem question="¿Es editable?" answer="Sí, todo el material es 100% editable e imprimible. Podés adaptarlo a tus necesidades específicas, agregar tu logo o modificar contenidos." data-id="element-190" />
            <AccordionItem question="¿Durante cuánto tiempo tengo acceso?" answer="El acceso es de por vida. Pagás una única vez y el material es tuyo para siempre, incluyendo futuras actualizaciones." data-id="element-191" />
            <AccordionItem question="¿Es seguro comprar aquí?" answer="Sí, tu pago es 100% seguro. Utilizamos pasarelas de pago encriptadas de nivel bancario para garantizar la seguridad de tus datos." data-id="element-192" />
          </div>

          <div className="mt-16 text-center" data-id="element-193">
            <button onClick={scrollToCheckout} className="bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-orange-500/30 transition-all transform hover:-translate-y-1" data-id="element-194">
              QUIERO ACCEDER AHORA
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-gray-400 py-12 text-center text-sm" data-id="element-195">
        <div className="container mx-auto px-4" data-id="element-196">
          <p data-id="element-197">
            &copy; {new Date().getFullYear()} Edulabs. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-198">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>
    </div>;
}